import React, { useState } from "react";
import BookDemoForm from "../../../../components/BookDemoForm/BookDemoForm";

const CTASection = () => {
  const [showFormModal, setShowFormModal] = useState(false);

  const handleFormToggle = () => {
    setShowFormModal(!showFormModal);
  };
  return (
    <section className="relative flex justify-center items-center px-4 sm:px-8 py-12 sm:py-16 bg-white">
      {/* Decorative Background Lines */}
      <div className="absolute inset-0 overflow-hidden">
        <svg
          className="absolute inset-0 w-full h-full"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 320"
        >
          <path
            fill="none"
            stroke="gray"
            strokeOpacity="0.2"
            strokeWidth="1"
            d="M0,320L80,293.3C160,267,320,213,480,202.7C640,192,800,224,960,224C1120,224,1280,192,1360,176L1440,160"
          />
        </svg>
      </div>

      {/* CTA Box */}
      <div className="relative bg-indigo-600 text-white rounded-3xl px-6 sm:px-10 py-10 sm:py-12 text-center max-w-lg sm:max-w-2xl shadow-lg">
        <h2 className="text-2xl sm:text-3xl font-bold mb-4">
          Let's scale together
        </h2>
        <p className="text-sm sm:text-lg text-gray-300 leading-relaxed">
          We've helped many businesses save <b>40K + hours</b> and <b>50% +</b>{" "}
          with automation.
          <br />
          Let us do the same for your company.
        </p>

        {/* Button */}
        <div className="mt-6 flex justify-center">
          <button
            className="bg-white text-indigo-600 px-5 sm:px-6 py-3 rounded-full text-sm sm:text-lg font-semibold shadow-md hover:bg-gray-100 transition duration-300 flex items-center justify-center gap-2 w-full sm:w-auto"
            onClick={handleFormToggle}
          >
            Book a Free Call →
          </button>
        </div>
      </div>
      {showFormModal && <BookDemoForm onClose={handleFormToggle} />}
    </section>
  );
};

export default CTASection;
